import { render, staticRenderFns } from "./RecoveryCodeForm.vue?vue&type=template&id=121e31c2&scoped=true&"
import script from "./RecoveryCodeForm.vue?vue&type=script&lang=js&"
export * from "./RecoveryCodeForm.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryCodeForm.vue?vue&type=style&index=0&id=121e31c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121e31c2",
  null
  
)

export default component.exports